import { Theme } from '@mui/material';

import makeStyles from '@mui/styles/makeStyles';

export const useFSLDatePickerStyles = makeStyles((theme: Theme) => ({
  root: {
    '& svg': {
      fill: theme.customPalette.red,
    },
  },
}));
